import React from 'react'
import styled from 'styled-components';

const Root = styled.div``;
const Container = styled.div``;
const TextWrapper = styled.div``;
const Text = styled.text`
color:red;
`;
const Profile = () => {
  return (
   <Root>
    <Container>
        <TextWrapper>
            <Text>xyz</Text>
        </TextWrapper>
    </Container>
   </Root>
  )
}

export default Profile